var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardFactors",class:_vm.customClass},[(_vm.src)?_c('img',{attrs:{"src":require(`../../assets/${_vm.src}`)}}):_vm._e(),_c('h3',{staticClass:"cardFactors__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('div',{staticClass:"cardFactors__text"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }